<template>
  <div class="match-interaction">
    <interaction-hint v-if="!readonly">
      <span class="hidden-md-and-up">
        Установите соответствие пар
      </span>
      <span class="hidden-sm-and-down">
        Установите соответствие пар, перетаскивая блоки в правой колонке мышью
      </span>
    </interaction-hint>
    <v-layout row>
      <v-flex>
        <v-list three-line>
          <template v-for="(item, index) in leftList">
            <v-list-tile :key="index">
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <label
                    class="answer ml-2"
                    :disabled="readonly"
                    v-html="item.text"
                  />
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
      <v-flex>
        <v-list three-line>
          <draggable
            :value="rightList"
            :options="sortableOptions"
            @input="sorted"
          >
            <template v-for="(item, index) in rightList">
              <v-list-tile :key="index">
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-layout align-center>
                      <v-icon v-if="!readonly" class="sort-handle">
                        reorder
                      </v-icon>
                      <label
                        class="answer ml-2"
                        :disabled="readonly"
                        v-html="item.text"
                      />
                    </v-layout>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </draggable>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>
<style>
.match-interaction .v-list__tile--link {
  cursor: default !important;
}
.match-interaction label[disabled] {
  cursor: no-drop !important;
}
.match-interaction .sort-handle {
  cursor: pointer;
}
</style>
<script type="text/babel">
import InteractionHint from './InteractionHint'
import draggable from 'vuedraggable'
export default {
  name: 'InteractionMatch',
  props: {
    matches: {
      type: [Array, Object],
      required: true
    },
    value: {
      required: true
    },
    readonly: {
      default: false
    }
  },
  computed: {
    sortableOptions() {
      return {
        handle: '.sort-handle'
      }
    },
    sequence() {
      if (this.value) {
        return String(this.value)
          .split(',')
          .map(e => Number(e))
      } else {
        let result = []
        for (let i = 0; i < this.matches.length; i++) {
          result.push(i + 1)
        }
        result.sort(() => {
          return 0.5 - Math.random()
        })
        return result
      }
    },
    leftList() {
      if (Array.isArray(this.matches)) {
        return this.matches.map((e, index) => {
          return {
            key: index + 1,
            index: e.index,
            text: e.left
          }
        })
      } else {
        return []
      }
    },
    rightList() {
      if (Array.isArray(this.matches)) {
        let unsorted = this.matches.map((e, index) => {
          return {
            key: index + 1,
            index: e.index,
            text: e.right
          }
        })
        let sorted = []
        this.sequence.forEach(index => {
          sorted.push(unsorted[index - 1])
        })
        return sorted
      } else {
        return []
      }
    }
  },
  methods: {
    sorted(value) {
      let result = value.map(e => e.key).join(',')
      this.$emit('input', result)
    }
  },
  components: {
    draggable,
    InteractionHint
  }
}
</script>
